
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.93 16.61"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M5.49 16.61a1.19 1.19 0 0 1-1.19-1.19v-2.19H1.88A1.88 1.88 0 0 1 0 11.35V1.88A1.88 1.88 0 0 1 1.88 0H17a1.89 1.89 0 0 1 1.89 1.88v9.47A1.89 1.89 0 0 1 17 13.23H8.84l-2.5 3a1.18 1.18 0 0 1-.85.38zM1.88 1a.89.89 0 0 0-.88.88v9.47a.88.88 0 0 0 .88.88H5.3v3.19a.19.19 0 0 0 .19.19.17.17 0 0 0 .12 0l2.76-3.33H17a.88.88 0 0 0 .89-.88V1.88A.89.89 0 0 0 17 1z"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"9.59","cy":"6.48","r":"1"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"5.66","cy":"6.48","r":"1"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"13.52","cy":"6.48","r":"1"}})])])])
          )
        }
      }
    